import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE } from '@utils/constant'
import { FULL_ROLE } from '@utils/helpers'
const adminListAgentAdminRoutes = {
  path: 'admin-list-agentadmin',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.agentAdmin.list'),
  },
  children: [
    {
      path: '',
      name: 'adminListAgentAdmin',
      component: () =>
        lazyLoadView(import('@views/AdminListAgentAdmin/list.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
      },
    },
    {
      path: 'edit',
      name: 'editAdminListAgentAdmin',
      component: () =>
        lazyLoadView(import('@views/AdminListAgentAdmin/edit.vue')),
      meta: {
        authRequired: FULL_ROLE,
        label: i18n.t('router.agentAdmin.edit'),
      },
    },
  ],
}

export default adminListAgentAdminRoutes
